<template lang="pug">
    div
        div()
            credit-note-search(
                :saleCreditNotes='saleCreditNotes' 
                @creditNote="searchCreditNoteResponse"
                )
        div( v-if ="showAmountPayment" )
            .title Monto Nota crédito:
            v-text-field.title#document-bank-pay-input(
                :mask="mixCurrencyMask(creditNotePayment, 12)"
                placeholder="Ingrese monto pagado por Documento Banco"
                prefix="$"
                v-model="creditNotePayment"
                :rules='[rules.required, rules.validPayment, rules.notZero]'
                @input="setTransbankPayment()"
                @keyup.enter="document.getElementById('transbank-voucher-num-input').focus()"
                readonly
                )
        div( v-if="showAlert" )
            v-alert(:value="true" type="warning") Nota de Crédito No encontrada
</template>

<script>
/* components */
import CreditNoteSearch from './creditNoteSearch/CreditNoteSearch'
/* mixins */
import PaymentRules from '@/mixins/PaymentRules'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import JSUtils from '@/mixins/CurrencyUtils'
/* vuex */
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'bank-document-payment',
    props: {
        saleCreditNotes: {
            type: Array,
            default: () => [],
        }
    },
    data: function() {
        return {
            //bankDocumentNumber: '',
            creditNotePayment: '',
            folioHasFound: null,
            creditNoteData:null,
        }
    },
    computed: {
        /**
         * 
         */
        ...mapState('CustomerPaymentModule', {
            paymentMethod: 'paymentMethod',
            total: state => state.total,
        }),
        /**
         * 
         */
        ...mapGetters('CustomerPaymentModule', {
            totalToPay: 'totalToPay',
        }),
        /**
         * 
         */
        allDocumentBankDataSet: function() {
            return (
                //this.bankDocumentNumber.length === 6 &&
                this.creditNotePayment != ''
                // this.creditNotePayment != '' &&
                // parseInt(this.creditNotePayment) <= this.totalToPay
            )
        },
        /**
         * 
         */
        showAlert: function (){
            return (this.creditNoteData === null && this.folioHasFound === false)
                ? true
                : false
        },
        /**
         * 
         */
        showAmountPayment: function () {
            return ( this.creditNoteData != null)
                ? true
                : false
        }
    },
    methods: {
        /**
         * 
         */
        ...mapActions('CustomerPaymentModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
        }),
        /**
         * 
         */
        setTransbankPayment() {
            if (parseInt(this.creditNotePayment) === 0) {
                this.setPayment('')
            } else {
                this.setPayment(this.creditNotePayment)
            }
        },
        /**
         * 
         */
        searchCreditNoteResponse(event){
            this.checkResponse(event)
        },
        /**
         * 
         */
        checkResponse(event){
            if( event === false ){
                this.setFolioHasFound( false )
            }
            else{
                this.setFolioHasFound( true )
                this.setCreditNote( event )
                this.setValuePayment()
            }
        },
        /**
         * 
         */
        setFolioHasFound(val){
            this.folioHasFound = val
        },
        /**
         * 
         */
        setCreditNote(creditNoteData){
            this.creditNoteData = {...creditNoteData}
        },
        getCreditNote(){
            return this.creditNoteData 
        },
        getCreditNoteTotal(){
            return parseInt( this.creditNoteData.total )
        },
        setValuePayment(){
            this.creditNotePayment = this.getCreditNoteTotal()
        }
    },
    watch: {
        /**
         * @description updates payment details in store depending of they are fully set in form or not.
         */
        allDocumentBankDataSet: function(newVal, oldVal) {
            if (newVal) {
                this.setPayment(this.creditNotePayment)
                let payload = {
                    sl_sale_credit_note_id: this.creditNoteData.id,
                    number: this.creditNoteData.number
                }
                this.setPaymentDetail(payload)
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },
        /**
         * @description If payment method changes (example: from debit to credit),
         * bankDocumentNumber data and payment data is reseted to their original values.
         */
        paymentMethod: function(newVal, oldVal) {
            //this.bankDocumentNumber = ''
            this.creditNotePayment = this.totalToPay.toString()
        },
        creditNotePayment: function(val) {
            this.setTransbankPayment()
        }
        // creditNoteData: function( val ) {
        //     console.log('credito note',val)
        // }
    },
    components: {
        'credit-note-search' : CreditNoteSearch,
    },
    mixins: [PaymentRules, CurrencyUtils, JSUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        //this.bankDocumentNumber = ''
        //this.creditNotePayment = this.totalToPay.toString()
        // this.$nextTick(() =>
        //     document.getElementById('document-bank-pay-input').focus()
        // )
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>